const UPDATE_INCOMING_INVITE = 'UPDATE_INCOMING_INVITE';
const TOGGLE_INVITE_MODAL = 'TOGGLE_INVITE_MODAL';
const SET_POPUP_LOADING = 'SET_POPUP_LOADING';
const SHOW_INVITATION_STATUS = 'SHOW_INVITATION_STATUS';

export {
  UPDATE_INCOMING_INVITE,
  TOGGLE_INVITE_MODAL,
  SET_POPUP_LOADING,
  SHOW_INVITATION_STATUS,
};
